import React from "react";
import { MapEmbedIframe } from "./elements";

const MapEmbed = ({ src, width = 500, height = 300, title }) => (
  <MapEmbedIframe
    width={width}
    height={height}
    src={src}
    title={title || "map"}
  />
);

export default MapEmbed;
